import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class FuncApiService {

  constructor(private http: HttpClient,
              public global: GlobalService) { }

  user = this.global.user;
  pass = this.global.pass;
  auth = btoa(this.user + ':' + this.pass);

  dominio = this.global.dominio;
  opcionalaUrl = this.dominio + '/backend/api/v2/functech';


  criptografar(corpo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(corpo);
    return this.http.post<any>(`${this.opcionalaUrl}/criptografar`, body, { headers })
      .toPromise();

  }


 


}

